import { useCallback } from 'react'
import { SendTransactionResult } from 'wagmi/actions'
import { useCallWithGasPrice } from 'hooks/useCallWithGasPrice'
import { useCandyLockContract } from 'hooks/useContract'

const useLockToken = () => {
  const { callWithGasPrice } = useCallWithGasPrice()
  const lockContract = useCandyLockContract()

  const onLock = useCallback(
    async (amount: string, duration: number, nftIds, rarities, proofs): Promise<SendTransactionResult> => {
      return callWithGasPrice(lockContract, 'lock', [amount, duration, nftIds, rarities, proofs])
    },
    [lockContract, callWithGasPrice],
  )

  const onClaim = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(lockContract, 'claimReward', [lid])
    },
    [lockContract, callWithGasPrice],
  )

  const onUnlock = useCallback(
    async (lid: number): Promise<SendTransactionResult> => {
      return callWithGasPrice(lockContract, 'unlock', [lid])
    },
    [lockContract, callWithGasPrice],
  )

  return { onLock, onClaim, onUnlock }
}

export default useLockToken
